module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal__content"
  }, [(_vm.args.projectUser.avatarKey) ? _c('div', {
    staticClass: "text-center mb30"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": '/serve/s/' + _vm.args.projectUser.avatarKey + '?w=96&h=96',
      "alt": _vm.args.projectUser.name
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex flex--justify-center"
  }, [_c('div', {
    staticClass: "form-row mb0 mr30"
  }, [_c('label', [_vm._v("User Name")]), _vm._v(" "), _c('h4', {
    staticClass: "text-regular"
  }, [_vm._v(_vm._s(_vm.args.projectUser.name) + " " + _vm._s(_vm.args.projectUser.surname))])]), _vm._v(" "), (_vm.checkUserRole(_vm.args.userRole, ['admin', 'projectManager']) || (_vm.checkUserRole(_vm.args.userProjectRole, ['owner', 'editor', 'viewer']) && _vm.checkUserRole(_vm.args.projectUser.userProjectRole, ['owner', 'editor', 'viewer', 'admin', 'projectManager']))) ? _c('div', {
    staticClass: "form-row mb0 mr30"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('h4', {
    staticClass: "text-regular mb0"
  }, [_c('a', {
    attrs: {
      "href": 'mailto:' + _vm.args.projectUser.email
    }
  }, [_vm._v(_vm._s(_vm.args.projectUser.email))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-row mb0"
  }, [_c('label', [_vm._v("Role")]), _vm._v(" "), _c('h4', {
    staticClass: "text-regular"
  }, [_vm._v(_vm._s(_vm._f("titleize")(_vm.args.projectUser.userProjectRole)))])])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex--justify-center mt30"
  }, [_c('button', {
    staticClass: "btn btn--wide btn--gray-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('modalClose')
      }
    }
  }, [_vm._v("Close")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-83341880","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/modals/UserInfoModal.vue
// module id = 447
// module chunks = 2